$(document).ready(function() {

  if (typeof WDN === 'undefined') {
    var WDN = {}; 
  }

  if (typeof WDN.Switcher === 'undefined') {

    WDN.Switcher = (function() {

      var _selectors = {
        wrap:  $(".PageToSwitch"),
        controlsWrap: $(".GarberRetur .controls"),
        controls: $(".GarberRetur a"),
        material: $(".MaterialItem"),
        collection: $(".CollectionItem")
      };

      function ReturnPageProductClick(elem) {
        var name = elem.data("name");
        var image = elem.data("image");
        var type = elem.data("type");
        $("#ProductImage img").attr("src", image);
        $("#ProductName").html(name);
        $("#ProductType").html(type);
      }


      function fetchReturnItems() {
        var handle = $(".CollectionItem.active").data("handle");
        var material = $(".MaterialItem.active").data("handle");
        var url = '/collections/' + handle + "/" + material + "?view=return";

        if (handle.length === 0) {
          url = '/collections/' + handle + "/?view=return";
        }

        var params = {
          method: 'GET',
          url: url,
          success: function(data) {
            console.log("data", data)
            var dataToShow = $(data).find(".CollectionSubCollections");
            
            console.log(dataToShow);
            if (dataToShow.find(".ProductItem").length > 0) {
              $("#SelectProducts .Error").hide();
              $("#SelectProducts .ProductWrap").html(dataToShow).show();
            } else {
              $("#SelectProducts .ProductWrap").html("").hide();
              $("#SelectProducts .Error").show();
            }
          }
        }

        $.ajax(params);
      }


      function ReturnPageProgress(index) {
        var wrap = $(".progress");
        var of = $(".progress .of");
        var total = $(".progress .total");

        wrap.show();
        of.html(index + 1);
        total.html(_selectors.wrap.length);
      }


      function ReturnPageUpdateControls(index) {
        var prev = _selectors.controlsWrap.find(".prev");
        var next = _selectors.controlsWrap.find(".next");
        var length = _selectors.wrap.length - 1;
        if (index === 0) {
          next.hide();
          prev.hide();
        } else {
          prev.show();
        }

        if (_selectors.wrap.eq(index).find(".active").length > 0) {
          next.show();
        } else {
          next.hide(); 
        }

        if (index === length) {
          next.hide();
        }

        if (_selectors.wrap.eq(index).attr("id") === 'SelectProducts') {
          if (_selectors.wrap.eq(index).find(".active").length === 0) {
            $("#SelectProducts .ProductWrap").html("");
            fetchReturnItems();
          } else {
            ReturnPageProductClick(_selectors.wrap.eq(index).find(".active"));
          }
        }
        _selectors.controlsWrap.data("control-index", index); 
        ReturnPageProgress(index);
      }

      function ReturnPageIndex(direction, index) {
        if (direction === 'next') {
          index += 1;
        } else {
          index -= 1;
        }
        return index;
      }

      function ReturnPageController(direction, index) {
        var newIndex = ReturnPageIndex(direction, index);
        _selectors.wrap.removeClass("visible");
        _selectors.wrap.eq(newIndex).addClass("visible");
        ReturnPageUpdateControls(newIndex);
      }

      _selectors.controls.on("click", function(e) {
        e.preventDefault();
        var $e = $(this);

        var direction = ($e.hasClass("next") ? "next" : "prev");
        var index = $e.parent().data("control-index");

        ReturnPageController(direction, index);
      });


      $(".TriggerReturnFoldOut").on("click", function(e) {
        e.preventDefault();
        
        if ($(this).hasClass("disabled")) {
          return;
        }

        $(".GarberRetur").slideDown(300);

        var offsetRetur = $(".GarberRetur").offset().top - 140;
        $("html, body").animate({ scrollTop: offsetRetur }, 600);

      });

      _selectors.material.on("click", function() {

        if ($("#SelectProducts").find(".active").length > 0) {
          $("#SelectProducts").find(".active").removeClass("active"); 
        }        
        _selectors.material.removeClass("active");
        $(this).addClass("active");

        var index = $(".controls").data("control-index");
        ReturnPageUpdateControls(index);
      });

      _selectors.collection.on("click", function() {
        $(".CollectionItem").removeClass("active");
        $(this).addClass("active");

        if ($("#SelectProducts").find(".active").length > 0) {
          $("#SelectProducts").find(".active").removeClass("active"); 
        }

        var index = $(".controls").data("control-index");
        ReturnPageUpdateControls(index);
      });



      $("body").on("click", ".ProductItem", function() {
        $(".ProductItem").removeClass("active");
        $(this).addClass("active");

        var index = $(".controls").data("control-index");
        ReturnPageUpdateControls(index);
      });


      $("#SubmitReturnForm").on("click", function() {
		$(".GarberRetur").hide();
        $("input#model").val($("#ProductName").text());
        $(".TriggerReturnFoldOut").text($("#ProductName").text()).addClass("disabled");
        $(".GarberRetur").slideUp(300);

      });

      function PageSwitchterInit() {
        _selectors.wrap.first().addClass("first").addClass("visible");
        _selectors.wrap.last().addClass("last");
        ReturnPageProgress(0);
        ReturnPageUpdateControls(0);
      }

      PageSwitchterInit();

    }()); 
  }
});